import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const pylonWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-pylon/web/PylonPage',
    label: 'Generate a Pylon API token and add it as an org-scoped connection.',
  },
  eventLabels: [
    {
      type: 'agent.source.pylon_issue',
      label: 'Pylon issue',
      tooltip: 'Agent triggered from a Pylon issue',
      style: 'system',
    },
  ],
  flowTriggerRenderers: [
    {
      triggerType: 'pylon_issue',
      label: 'Pylon issue',
      icon: 'LifeBuoy',
      componentPath: '@reflex/plugin-pylon/web/PylonFlowTriggerSummary',
    },
  ],
};
